export default "__VITE_ASSET__CMIMLJ9H__"